import { I18nKeys } from 'i18n/keys';
import { defineMessages } from 'react-intl';

export const TenantsMessages = defineMessages({
  tenants: {
    id: I18nKeys.Tenants,
    defaultMessage: 'Tenants',
  },
  nameRequiredError: {
    id: I18nKeys.TenantsNameRequiredError,
    defaultMessage: 'Tenant name is required',
  },
  aliasRequiredError: {
    id: I18nKeys.TenantsAliasRequiredError,
    defaultMessage: 'Tenant alias is required',
  },
  adminEmailRequiredError: {
    id: I18nKeys.AdminEmailRequiredError,
    defaultMessage: 'Tenant administrator email is required',
  },
});
